module.exports = __webpack_public_path__ + "static/media/Category-Events.75b7e4a7.jpg";